import PageContainer from "../../componets/containers/PageContainer";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {QueryParams} from "../../types";
import vehiclesApi from "../../services/vehiclesApi";
import Input from "../../componets/inputs/Input";
import {FaArrowDown, FaSearch} from "react-icons/fa";
import Carousel from "react-multi-carousel";
import Str from "../../helpers/Str";
import {BiArea} from "react-icons/bi";
import {BsHouseCheckFill} from "react-icons/bs";

export default function HomeVehicles() {
    const [stateSearch, setStateSearch] = useState({
        marca: '',
        modelo: '',
        ano: ''
    })

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [vehicles, setVehicles] = useState([]);

    const [loadVehicles, setLoadVehicles] = useState(true);
    const [totalPage, setTotalPage] = useState();
    const [pageTo, setPageTo] = useState();

    // @ts-ignore
    const [params, setParams]: QueryParams = useState({
        page: '1',
        perPage: '15',
        whereBig: '',
    });

    const getVehicles = async (page?: number) =>{


        if(!page){
            setLoading(true)
        }
        let whereBig = '';

        if (stateSearch.marca){
            whereBig += 'where=marca,=,'+stateSearch.marca
        }
        if (stateSearch.modelo){
            if (whereBig.length){
                whereBig += '&where=modelo,=,'+stateSearch.modelo
            }else{
                whereBig += 'where=modelo,=,'+stateSearch.modelo
            }
        }
        if (stateSearch.ano){
            if (whereBig.length){
                whereBig += '&where=ano,=,'+stateSearch.ano
            }else{
                whereBig += 'where=ano,=,'+stateSearch.ano
            }
        }

        const newParams = {...params};

        if (page){
            newParams.page = page;
        }else if(whereBig.length){
            newParams.page = 1
        }
        newParams.whereBig = whereBig;
        setParams(newParams);
        const {data, isError} = await vehiclesApi.getVehiclesHome(newParams);
        if (!isError){
            if(!page){
                setTotalPage(data.total)
                setPageTo(data.to)
                setVehicles(data.data)
            }else{
                let countries = [].concat(vehicles, data.data);
                setTotalPage(data.total)
                setPageTo(data.to)
                setVehicles(countries)
            }
        }
        setLoading(false)
        setLoadVehicles(false)
    }

    useEffect(() => {
        getVehicles()
    }, [])

    const handleChange = (value: string, input: string) => {
        const newVue = {...stateSearch}
        // @ts-ignore
        newVue[input] = value
        setStateSearch(newVue);
    };

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            partialVisibilityGutter: 40, // this is optional if you are not using partialVisible props
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            partialVisibilityGutter: 30, // this is optional if you are not using partialVisible props
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 30, // this is optional if you are not using partialVisible props
        },
    };
    const loadNewVehicles = async () => {
        setLoadVehicles(true);
        await getVehicles(parseInt(params.page) + 1)
    }

    return (
        <PageContainer >

            {
                loading ?
                    <div className={'w-full h-[calc(90vh_-_80px)]'}>
                        <span className="flex items-center justify-center w-full h-full h-7">
                            <svg className="animate-spin -ml-1 mr-3 h-[45px] w-[45px] text-[#003641]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#003641"  strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                    </div>
                    :
                    <div className={'flex flex-col items-center justify-center gap-4 md:mb-[4rem]'}>
                        <div className="flex flex-col md:flex-row items-center gap-2 ">
                            <div className="grid grid-cols-12 gap-5 content-center ">
                                <Input
                                    label={'Marca'}
                                    value={stateSearch.marca}
                                    className={'md:col-span-4 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'marca')}
                                />
                                <Input
                                    label={'Modelo'}
                                    value={stateSearch.modelo}
                                    className={'md:col-span-4 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'modelo')}
                                />
                                <Input
                                    label={'Ano'}
                                    value={stateSearch.ano}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'ano')}
                                />
                                <div className={'flex items-end'}>
                                    <button onClick={() => getVehicles()} className="w-[50px] h-[50px]">
                                        <FaSearch/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            vehicles.length ?
                                <>

                                    <div className="grid md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-4">
                                        {
                                            vehicles.map((vehicle: any) => {
                                                return (
                                                    <div className="flex flex-col max-w-sm rounded overflow-hidden shadow-2xl border p-2">
                                                        <Carousel
                                                            additionalTransfrom={0}
                                                            arrows
                                                            autoPlaySpeed={3000}
                                                            autoPlay
                                                            centerMode={false}
                                                            className=""
                                                            containerClass="container-with-dots"
                                                            dotListClass=""
                                                            draggable
                                                            focusOnSelect={false}
                                                            infinite={vehicle.images.length > 1}
                                                            keyBoardControl
                                                            minimumTouchDrag={80}
                                                            renderButtonGroupOutside={false}
                                                            renderDotsOutside={false}
                                                            responsive={responsive}
                                                            itemClass={'p-3'}
                                                            showDots={vehicle.images.length > 1}
                                                        >
                                                            {
                                                                vehicle.images.map((image: any) => {
                                                                    return (
                                                                        <div
                                                                            className={'w-full flex p-1 gap-1 justify-center items-center '}>
                                                                            <img
                                                                                className={'w-[350px] h-[250px]'}
                                                                                src={image.image_path}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </Carousel>
                                                        <div className="p-1 ">
                                                            <a href={'#'}>
                                                                <h5 className="mb-2 text-[18px] font-bold tracking-tight text-gray-900  w-full flex flex-col items-center">
                                                                    <div>{vehicle.marca} {vehicle.modelo}</div>
                                                                </h5>
                                                            </a>
                                                            <p className="mb-3 font-normal text-gray-700 flex flex-col items-center">
                                                                <div className={'flex w-full items-center justify-center gap-1'}>
                                                                    <div>{vehicle.ano}</div>
                                                                </div>
                                                            </p>

                                                        </div>
                                                        <div className={'flex justify-between items-center gap-3'}>
                                                            <div className={'px-3 py-2 text-[25px] font-bold text-[#003641]'}>
                                                                {Str.currencyMask(vehicle.valor)}
                                                            </div>
                                                            <a href={'view/veiculo/'+vehicle.id} className="inline-flex h-[45px] items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#003641] rounded-lg hover:bg-opacity-80   ">
                                                                Ver veículo
                                                                <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                                                                     aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                                     fill="none" viewBox="0 0 14 10">
                                                                    <path stroke="currentColor" stroke-linecap="round"
                                                                          stroke-linejoin="round" stroke-width="2"
                                                                          d="M1 5h12m0 0L9 1m4 4L9 9"/>
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                    <div className={'w-full flex justify-center mt-3 mb-3'}>
                                        {
                                            pageTo ?
                                                totalPage != pageTo ?
                                                    <button
                                                        onClick={() => loadNewVehicles()}
                                                        className={'border w-[50px] h-[50px] border-border border-2 items-center flex justify-center rounded-full'}>
                                                        {
                                                            loadVehicles ?
                                                                <span className="items-center flex justify-center h-7">
                                                                        <svg
                                                                            className="animate-spin  h-[20px] w-[20px] text-border"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12"
                                                                                r="10" stroke="currentColor"
                                                                                strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor"
                                                                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                        </svg>
                                                                    </span>
                                                                :
                                                                <FaArrowDown/>
                                                        }
                                                    </button>
                                                    :
                                                    ''
                                                :
                                                ''
                                        }

                                    </div>
                                </>

                                /*<div className={'flex flex-col md:w-[700px] gap-3 mb-[20px]'}>
                                    {
                                        vehicles.map((vehicle: any) => {
                                            return (
                                                <div className={'rounded-xl  w-full bg-gray-50 p-5 shadow-md'}>
                                                    <div className={'flex justify-end  mb-2 '}>
                                                        <div>
                                                            <button
                                                                onClick={() => navigate('/view/veiculo/' + vehicle.id)}
                                                                className={'bg-blue-500 hover:bg-blue-700 text-white font-semibold py-1 px-3 rounded'}>Ver
                                                                veículo
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className={''}>
                                                        <Carousel
                                                            additionalTransfrom={0}
                                                            arrows
                                                            autoPlaySpeed={3000}
                                                            autoPlay
                                                            centerMode={false}
                                                            className=""
                                                            containerClass="container-with-dots"
                                                            dotListClass=""
                                                            draggable
                                                            focusOnSelect={false}
                                                            infinite={vehicle.images.length > 1}
                                                            keyBoardControl
                                                            minimumTouchDrag={80}
                                                            renderButtonGroupOutside={false}
                                                            renderDotsOutside={false}
                                                            responsive={responsive}
                                                            itemClass={'p-3'}
                                                            showDots={vehicle.images.length > 1}
                                                        >
                                                            {
                                                                vehicle.images.map((image: any) => {
                                                                    return (
                                                                        <div
                                                                            className={'w-full flex p-1 gap-1 justify-center items-center '}>
                                                                            <img className={'h-[350px]'}
                                                                                 src={image.image_path}/>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </Carousel>
                                                        <div className={'text-[16px] mt-4 font-semibold gap-3 flex'}>
                                                            <div>Marca: {vehicle.marca} </div>
                                                            <div>Modelo: {vehicle.modelo} </div>
                                                            <div>Ano: {vehicle.ano} </div>
                                                        </div>
                                                        <div className={'text-[16px] mt-4 font-semibold flex'}>
                                                            <div>{vehicle.descricao} </div>
                                                        </div>
                                                        <div className={'text-[24px] font-bold mt-4'}>
                                                            {Str.currencyMask(vehicle.valor)}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    <div className={'w-full flex justify-center mt-3 mb-3'}>
                                        {
                                            pageTo ?
                                                totalPage != pageTo ?
                                                    <button
                                                        onClick={() => loadNewVehicles()}
                                                        className={'border w-[50px] h-[50px] border-border border-2 items-center flex justify-center rounded-full'}>
                                                        {
                                                            loadVehicles ?
                                                                <span className="items-center flex justify-center h-7">
                                                                        <svg
                                                                            className="animate-spin  h-[20px] w-[20px] text-border"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12"
                                                                                r="10" stroke="currentColor"
                                                                                strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor"
                                                                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                        </svg>
                                                                    </span>
                                                                :
                                                                <FaArrowDown/>
                                                        }
                                                    </button>
                                                    :
                                                    ''
                                                :
                                                ''
                                        }

                                    </div>
                                </div>*/
                                :
                                <div className={'flex flex-col md:flex-row items-center'}>

                                    <div
                                        className="bg-green-300 border-l-4 text-green-700 border-green-700 p-4 md:w-[900px]"
                                        role="alert">
                                        Nenhum veículo cadastrado
                                    </div>
                                </div>
                        }
                    </div>


            }
        </PageContainer>
    )
}